<template>
    <el-cascader v-model="currentValue"
        :options="dataSource"
        :separator="separator"
        :props="{value: 'id'}"
        :placeholder="placeholder"
        :multiple="multiple"
        :multiple-limit="multipleLimit"
        :disabled="disabled"
        :clearable="clearable"
        :collapse-tags="collapseTags"
        :filterable="filterable"
        :no-match-text="noMatchText"
        :no-data-text="noDataText">
    </el-cascader>
</template>

<script>
import Select from './select.js'
export default {
    name: 'v-cascader',
    mixins: [Select],
    props: {
        value: {
            type: Array,
            default () {
                return []
            }
        },
        separator: {
            type: String,
            default: '/'
        }
    },
    data () {
        return {
            currentValue: []
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/cascader.vue